/**
 * Casino games online — `/betting-gaming/casino-games`
 */
import { CASINO_GAMES_SLUG, casinoGamesDefaultData } from "./casinoGamesData";
import { CasinoGamesArticlesTab, CasinoGamesMediaTab, CasinoGamesOverviewTab } from "./CasinoGamesDesign";

export const casinoGamesModule = {
  slug: CASINO_GAMES_SLUG,
  getDefaultData: () => casinoGamesDefaultData,
  Views: {
    overview: CasinoGamesOverviewTab,
    articles: CasinoGamesArticlesTab,
    media: CasinoGamesMediaTab,
  },
};
